import { Component, OnInit } from '@angular/core';
import { TransactionSerie } from '../_types/transaction-serie';
import { TransactionType } from '../../transactions/_types/transaction-type';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { TransactionsSeriesService } from '../_services/transactions-series.service';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { OnSameUrlNavigation, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TransactionsTypesService } from '../../transactions/_services/transactions-types.service';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { firstValueFrom } from 'rxjs';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { FilterFieldConfig } from 'src/app/core/filter-panel/filter-field.model';
import { LoginService } from '../../login/login.service';

@Component({
    selector: 'app-transactions-series-list',
    templateUrl: './transactions-series-list.component.html',
    styleUrls: ['./transactions-series-list.component.scss'],
    host: { class: 'list-page' },
    standalone: false
})
export class TransactionsSeriesListComponent implements OnInit {
  public transactionsSeries: TransactionSerie[] = [];
  public transactionsTypes: TransactionType[] = [];
  public totalRecords: number = 0;
  public loading: boolean = false;
  private lastGridEvent: any;
  public filters: any = {
    name: new Filter(FilterOperation.contains, 'name'),
    transactionTypeId: new Filter(FilterOperation.equals, 'transactionTypeId'),
  };

  public typeOptions: { label: string; value: any }[] = [];
  public fieldsConfig: FilterFieldConfig[] = [
    { filter: this.filters.name, type: 'text', label: 'Nombre', base: true },
    { filter: this.filters.transactionTypeId, type: 'select', label: 'Tipo', options: this.typeOptions, filterable: true, base: true }
  ];
  public allowWrite: boolean = false;
  public allowDelete: boolean = false;

  constructor(
    private transactionsSeriesService: TransactionsSeriesService,
    private topbarService: TopbarService,
    private router: Router,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private transactionsTypesService: TransactionsTypesService,
    private loginService: LoginService
  ) {   
  }

  ngOnInit(): void {
    this.topbarService.setTitle("Series de transacciones");
    this.topbarService.addAction("Nuevo", "pi pi-plus", false, () => {
      this.edit({} as TransactionSerie);
    });
    this.allowWrite = this.loginService.hasPermission("TRANSACTION_SERIES.WRITE");
    this.allowDelete = this.loginService.hasPermission("TRANSACTION_SERIES.DELETE");
    this.loadTransactionTypes();
  }

  async loadTransactionTypes() {
    let params: IParamsCollection = {}
    let response = await firstValueFrom(this.transactionsTypesService.all(params));
    this.transactionsTypes = response.data;
    this.typeOptions.length = 0;
    this.typeOptions.push(...response.data.map((t: any) => ({ label: t.name, value: t.id })));
  }

  public async loadData($event: any) {

    this.lastGridEvent = $event;

    let params: IParamsCollection = {
      page: { number: $event.first + 1, size: $event.rows },
      include: ['transactionType'],
    }

    if (typeof $event.sortField != "undefined") params.sort = [($event.sortOrder > 0 ? "-" : "") + $event.sortField];

    //creamos filtros
    params.filter = FilterBuilder.fromObject(this.filters).build();


    let response = await firstValueFrom(this.transactionsSeriesService.all(params));
    this.transactionsSeries = response.data;
    this.totalRecords = response.meta['total'];
    this.topbarService.setCount(this.totalRecords);
  }

  clearFilters() {
    this.filters = {};
    this.search();
  }

  search() {
    this.lastGridEvent.first = 0;
    this.loadData(this.lastGridEvent);
  }

  edit(transactionSerie: TransactionSerie) {
    this.router.navigate(['transactionsSeries/' + (transactionSerie && Object.keys(transactionSerie).length > 0 ? transactionSerie.id : 0)])
  }

  delete(transactionSerie: TransactionSerie) {
    if (this.allowDelete) {
      this.confirmationService.confirm({
        message: "¿Está seguro que desea eliminar la serie de transacción?",
        header: "Eliminar serie de transacción",
        acceptLabel: "Aceptar",
        rejectLabel: "Cancelar",
        acceptButtonStyleClass: "p-button-danger",
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.transactionsSeriesService.delete(transactionSerie.id).subscribe({
            next: (data: any) => {
              this.messageService.add({ closable: true, severity: 'success', detail: "Serie de transacción eliminada correctamente" });
              this.loadData(this.lastGridEvent);
            },
            error: (error: any) => {
              this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
            }
          });
        },
        reject: (error: any) => {
          this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
        }
      });
    }
  }
}
